import { ASSESSMENT_THREADS, GROUP_THREADS, PATIENT_THREADS } from '../collections/names'
import { type ThreadType } from '../types'

export const messageThreadCollections: Record<ThreadType, string> = {
  assessment: ASSESSMENT_THREADS,
  patient: PATIENT_THREADS,
  group: GROUP_THREADS,
  direct: GROUP_THREADS,
}
